// eslint-disable-next-line no-unused-vars
import React from 'react';
import { Checkbox } from '@carbon/react';
import { func, bool, object } from 'prop-types';
import { useTranslation } from 'react-i18next';
import FilterListComponent from 'Components/Filters/FilterListComponent';
import usePermissions from 'Hooks/usePermissions';

const OffersFilter = ({ onAvailabilityChange, open, onToggle, availability }) => {
  const { t } = useTranslation();
  const { isExternalReseller } = usePermissions();
  return (
    <FilterListComponent
      filterTitle={ t('filters.categoryOffers') }
      showSearch={ false }
      onToggle={ onToggle }
      cx={ open ? 'open' : 'closed' }
    >
      <div className="options">
        <div className="filterItem">
          <Checkbox
            name="promotions"
            value="promotions"
            id="promotions"
            checked={ availability.promotions }
            onChange={ (_, { checked }) => onAvailabilityChange('promotions')(checked) }
            labelText={ t('filters.promotions') }
          />
        </div>
        {
          !isExternalReseller && (
            <div className="filterItem">
              <Checkbox
                name="resealed"
                value="resealed"
                id="resealed"
                checked={ availability.resealed }
                onChange={ (_, { checked }) => onAvailabilityChange('resealed')(checked) }
                labelText={ t('filters.resealed') }
              />
            </div>
          )
        }
        <div className="filterItem">
          <Checkbox
            name="clearance"
            value="clearance"
            id="clearance"
            checked={ availability.clearance }
            onChange={ (_, { checked }) => onAvailabilityChange('clearance')(checked) }
            labelText={ t('filters.clearance') }
          />
        </div>
        {/*<div className="filterItem">*/}
        {/*  <Checkbox*/}
        {/*    name="eol"*/}
        {/*    value="eol"*/}
        {/*    id="eol"*/}
        {/* checked={ availability.eol }  */}
        {/*    labelText={ t('filters.eol') }*/}
        {/*  />*/}
        {/*</div>*/}
      </div>
    </FilterListComponent>
  );
};

OffersFilter.propTypes = {
  onAvailabilityChange: func,
  availability: object,
  onToggle: func,
  open: bool
};

export default OffersFilter;
